import React, { ButtonHTMLAttributes } from "react";

//#region 型定義
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** ボタンの種類を指定 */
  variant?: "primary" | "secondary" | "danger";
  /** ローディング状態 */
  isLoading?: boolean;
  /** ボタンのサイズ */
  size?: "small" | "medium" | "large";
}
//#endregion

/**
 * ボタンコンポーネント
 * @description カスタマイズ可能なボタンを提供するコンポーネント
 */
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  isLoading = false,
  size = "medium",
  className = "",
  disabled,
  ...props
}) => {
  // バリアントに基づくスタイル
  const variantStyles = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    secondary: "bg-gray-200 hover:bg-gray-300 text-gray-800",
    danger: "bg-red-600 hover:bg-red-700 text-white",
  };

  // サイズに基づくスタイル
  const sizeStyles = {
    small: "px-3 py-1.5 text-sm",
    medium: "px-4 py-2 text-base",
    large: "px-6 py-3 text-lg",
  };

  // 無効状態のスタイル
  const disabledStyle =
    disabled || isLoading ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      className={`
                ${variantStyles[variant]}
                ${sizeStyles[size]}
                ${disabledStyle}
                rounded-md
                font-medium
                shadow-sm
                transition-colors
                duration-200
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-500
                ${className}
            `}
      disabled={disabled || isLoading}
      {...props}
    >
      <div className="flex items-center justify-center space-x-2">
        {isLoading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        {children}
      </div>
    </button>
  );
};

export default Button; 